export default "__VITE_ASSET__BWYREiCv__"